import { css } from '@emotion/react';
import styled from '@emotion/styled';
import FONT from '../../../styles/emotion/fonts';

import GOLD_FOIL from '../../../assets/images/paper/gold_foil_tag@2x.png';

export const Tag = styled.div<{ foil?: boolean }>`
  background-color: #ebf1f9;
  border-radius: 50px;
  color: #276588;
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_BOLD};
  line-height: 1.42857143;
  padding: 3px 9px;
  text-transform: uppercase;
  underline: none;

  ${(props) =>
    props.foil &&
    css`
      background: url(${GOLD_FOIL});
      background-repeat: no-repeat;
      background-size: 94px 20px;
      height: 20px;
      width: 94px;
    `}
`;
